import { Pipe, PipeTransform } from '@angular/core';

import { Mercado } from '../../mercado';

@Pipe({
    name: 'mercadoSituacaoFilter',
    pure: false
})
export class MercadoSituacaoFilterPipe implements PipeTransform {
    /** Filtra os mercados pela situação informada */
    transform(entities: Mercado[], situacao: number = null): Mercado[] {
        if (!entities) {
            return [];
        }
        // Retorna todos mercados quando não for informada uma situação para filtar
        if (!situacao) {
            return entities;
        }

        return entities.filter(entityFilter => entityFilter.situacao === situacao);
    }
}
